import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const InviteRedirect = () => {
  const { code } = useParams();

  useEffect(() => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const fallback = 'https://discord.gg/aqmoptimisation';
    fetch(`${API}/api/referral/resolve-invite/${code}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { window.location.href = (d && d.discord_url) || fallback; })
      .catch(() => { window.location.href = fallback; });
  }, [code]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-white gap-3" data-testid="invite-redirect">
      <Loader2 className="w-8 h-8 text-cyan-400 animate-spin" />
      <p className="text-gray-300">Redirection vers le Discord AqmOpti…</p>
    </div>
  );
};

export default InviteRedirect;
